import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

// SETUP COLORS

export const grey = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
};

export const primary = {
  lighter: "#C8E6C9", // Fresh green lighter shade
  light: "#66BB6A",   // Fresh green light shade
  main: "#2E7D32",    // Professional green main color
  dark: "#1B5E20",    // Deep green dark shade
  darker: "#0D3F14",  // Very deep green darker shade
  contrastText: "#FFFFFF",
};

export const secondary = {
  lighter: "#E1BEE7",
  light: "#BA68C8",
  main: "#7B1FA2",
  dark: "#4A148C",
  darker: "#311B92",
  contrastText: "#FFFFFF",
};

export const info = {
  lighter: "#CAFDF5",
  light: "#61F3F3",
  main: "#00B8D9",
  dark: "#006C9C",
  darker: "#003768",
  contrastText: "#FFFFFF",
};

export const success = {
  lighter: "#C8FAD6",
  light: "#5BE49B",
  main: "#00A76F",
  dark: "#007867",
  darker: "#004B50",
  contrastText: "#FFFFFF",
};

export const warning = {
  lighter: "#FFF5CC",
  light: "#FFD666",
  main: "#FFAB00",
  dark: "#B76E00",
  darker: "#7A4100",
  contrastText: grey[800],
};

export const error = {
  lighter: "#FFE9D5",
  light: "#FFAC82",
  main: "#FF5630",
  dark: "#B71D18",
  darker: "#7A0916",
  contrastText: "#FFFFFF",
};

export const common = {
  black: "#000000",
  white: "#FFFFFF",
};

export const action = {
  hover: alpha(grey[500], 0.08),
  selected: alpha(grey[500], 0.16),
  disabled: alpha(grey[500], 0.8),
  disabledBackground: alpha(grey[500], 0.24),
  focus: alpha(grey[500], 0.24),
  hoverOpacity: 0.08,
  disabledOpacity: 0.48,
};

const base = {
  primary,
  secondary,
  info,
  success,
  warning,
  error,
  grey,
  common,
  divider: alpha(grey[500], 0.2),
  action,
};

// ----------------------------------------------------------------------

export function palette(mode = "dark") {
  const isLight = mode === "light";
  
  return {
    ...base,
    mode,
    text: {
      primary: isLight ? grey[800] : "#FFFFFF",
      secondary: isLight ? grey[600] : grey[400],
      disabled: isLight ? grey[500] : grey[600],
    },
    background: {
      paper: isLight ? "#FFFFFF" : "#1A1A1A",
      default: isLight ? grey[100] : "#0A0A0A",
      neutral: isLight ? grey[200] : grey[800],
    },
    action: {
      ...base.action,
      active: isLight ? grey[600] : grey[400],
      hover: isLight ? alpha(grey[500], 0.08) : alpha(grey[500], 0.16),
      selected: isLight ? alpha(grey[500], 0.16) : alpha(grey[500], 0.24),
    },
    divider: isLight ? alpha(grey[500], 0.2) : alpha(grey[500], 0.12),
  };
}
